<template>
    <div>
        <a-row>
            <a-col :span="1"/>
            <a-col :span="8">
                医疗机构：
                <a-input style="width: calc(100% - 100px)" v-model="hospital"/>
            </a-col>
            <a-col :span="4">
                <a-button type="primary" @click="selectOrgList">
                    查询
                </a-button>
            </a-col>
            <a-col :span="4">
                <a-button type="primary" @click="addOrg">
                    新增
                </a-button>
            </a-col>
        </a-row>
        <a-table :columns="columns" :data-source="data.data" bordered :pagination="false" rowKey="id">
            <template slot="operation" slot-scope="text,row">
                <a style="padding-left:5px;" @click="edit(row)">编辑</a>
                <a-divider type="vertical"/>
                <a style="padding-left:5px;color:red" @click="delCar(row)">删除</a>
            </template>
        </a-table>
        <my-page :data="data" @change="onChange"/>
        <a-modal v-model="visible"
                 title="医疗机构信息"
                 width="70%"
                 :centered="true"
                 :maskClosable="false"
                 :bodyStyle="modalBodyStyle"
                 ok-text="确定"
                 cancel-text="取消"
                 @ok="add"
                 @cancel="visible=false">
            <a-row>
                <a-col :span="1"/>
                <a-col :span="2">
                    序号：
                </a-col>
                <a-col :span="4">
                    <a-input-number style="width: 100%" v-model.trim="form.orderNo"/>
                </a-col>
                <a-col :span="1"/>
                <a-col :span="2">
                    名称：
                </a-col>
                <a-col :span="4">
                    <a-input v-model.trim="form.name"/>
                </a-col>
                <a-col :span="1"/>
                <a-col :span="2">
                    电话：
                </a-col>
                <a-col :span="4">
                    <a-input v-model.trim="form.phone"/>
                </a-col>
            </a-row>
            <a-row style="margin-top: 10px;margin-bottom: 20px">
                <a-col :span="1"/>
                <a-col :span="2">
                    地址：
                </a-col>
                <a-col :span="4">
                    <a-select default-value="lucy" style="width: 195px"  v-model.trim="form.address">
                      <a-select-option :value="item.value" v-for="item of addressList" :key="item.value">
                        {{item.name}}
                      </a-select-option>
                  
                    </a-select>
                    <!-- <a-input v-model.trim="form.address"/> -->
                </a-col>
                <a-col :span="1"/>
                <a-col :span="2">
                    描述：
                </a-col>
                <a-col :span="4">
                    <a-input v-model.trim="form.descpt"/>
                </a-col>
            </a-row>
            <a-tabs v-model="tabKey" default-active-key="1" @change="changeTab">
                <a-tab-pane key="1" tab="联系人信息">
                    <a-table :columns="columnsChildren"
                             :data-source="form.contacts"
                             :scroll="{y:'38vh'}"
                             size="small"
                             :pagination="false"
                             rowKey="id">
                        <template
                                v-for="col in ['name', 'phone','descpt']"
                                :slot="col"
                                slot-scope="text, record">
                            <div :key="col">
                                <a-input v-model.trim="record[col]"/>
                            </div>
                        </template>
                        <template slot="orderNo" slot-scope="text, record">
                            <a-input-number v-model.trim="record.orderNo"/>
                        </template>
                        <template slot="operation" slot-scope="text, record">
                            <a style="color: red" @click="deleteLine(record)">{{record.isDel==='1'?'已删除':'删除'}}</a>
                        </template>
                    </a-table>
                </a-tab-pane>
                <a-tab-pane key="2" tab="位置信息">
                    <baidu-map class="map"
                               :center="center"
                               :zoom="17"
                               :scroll-wheel-zoom="true"
                               @mousemove="syncPolyline"
                               @click="paintPolyline"
                               @rightclick="newPolyline">
                        <template v-if="polyline.editing">
                            <bm-control anchor="BMAP_ANCHOR_TOP_RIGHT">
                                <ul>
                                    <li :style="fenceShape ==='polygon'?'background-color: cornflowerblue':''"
                                        @click="fenceShape = 'polygon'"><img
                                            src="../../assets/polygon.png" alt="多边形"/></li>
                                    <li :style="fenceShape ==='circular'?'background-color: cornflowerblue':''"
                                        @click="fenceShape = 'circular'"><img src="../../assets/circular.png"
                                                                              alt="圆形"/></li>
                                    <li><img src="../../assets/closeDraw.png" alt="结束绘制"/></li>
                                </ul>
                            </bm-control>
                            <bm-circle v-if="fenceShape ==='circular'" :center="circularObj.center"
                                       :radius="circularObj.radius"
                                       stroke-color="blue"
                                       :stroke-opacity="0.5"
                                       :stroke-weight="2"
                                       :editing="true"
                                       @lineupdate="updateCirclePath"/>
                            <bm-polyline v-else :path="polygonList"/>
                        </template>
                        <template v-else>
                            <bm-circle v-if="fenceShape==='circular'" :center="circularObj.center"
                                       :radius="circularObj.radius"
                                       @lineupdate="updateCirclePath"
                                       stroke-color="blue" :stroke-opacity="0.5" :stroke-weight="2"/>
                            <bm-polygon v-else :path="polygonList" stroke-color="blue"
                                        :stroke-opacity="0.5" :stroke-weight="2"/>
                        </template>
                    </baidu-map>
                </a-tab-pane>
                <template slot="tabBarExtraContent">
                    <div v-if="tabKey==='1'">
                        <a-button type="primary" @click="addLine">
                            新增
                        </a-button>
                    </div>
                    <div v-else-if="tabKey==='2'">
                        <a-button :disabled="polyline.editing" type="primary"
                                  @click="setNull">
                            {{ polyline.editing ? '鼠标右键结束绘制' : '开始绘制' }}
                        </a-button>
                    </div>
                </template>
            </a-tabs>

        </a-modal>
        <a-modal v-model="delVisible"
                 title="提示"
                 width="400px"
                 ok-text="确定"
                 cancel-text="取消"
                 @ok="delOk"
                 @cancel="cancel">
            <a class="Tips">是否确定删除!</a>
        </a-modal>
    </div>
</template>

<script>
    import {getOrgQueryList, orgEditDetail, orgDelDetail} from './js/ApiBasic';
    import {modalBodyStyle} from "../../config/Config"

    const columns = [
        {
            title: '序号',
            dataIndex: 'orderNo',
            key: 'orderNo',
            ellipsis: true,
        },
        {
            title: '医疗机构名称',
            dataIndex: 'name',
            key: 'name',
            ellipsis: true,
        },
        {
            title: '医疗机构联系电话',
            dataIndex: 'phone',
            key: 'phone',
            ellipsis: true,
        },
        {
            title: '医疗机构联系地址',
            dataIndex: 'address',
            key: 'address',
            ellipsis: true,
        },
        {
            title: '描述',
            dataIndex: 'descpt',
            key: 'descpt',
            ellipsis: true,
        },
        {
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            width: '120px',
            align: 'center',
            scopedSlots: {customRender: 'operation'},
        }
    ];
    const columnsChildren = [
        {
            title: '序号',
            dataIndex: 'orderNo',
            key: 'orderNo',
            ellipsis: true,
            scopedSlots: {customRender: 'orderNo'},
        },
        {
            title: '人员名称',
            dataIndex: 'name',
            key: 'name',
            ellipsis: true,
            scopedSlots: {customRender: 'name'},
        },
        {
            title: '联系电话',
            dataIndex: 'phone',
            key: 'phone',
            ellipsis: true,
            scopedSlots: {customRender: 'phone'},
        },
        {
            title: '描述',
            dataIndex: 'descpt',
            key: 'descpt',
            ellipsis: true,
            scopedSlots: {customRender: 'descpt'},
        },
        {
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            width: '120px',
            align: 'center',
            scopedSlots: {customRender: 'operation'},
        }
    ];
    export default {
        data() {
            return {
                columns,
                columnsChildren,
                modalBodyStyle,
                hospital: '',
                visible: false,
                delVisible: false,
                data: {},
                lines: {},
                form: {
                    orderNo: '',
                    name: '',
                    phone: '',
                    address: '',
                    descpt: '',
                    contacts: [],
                    positions: [],
                },
                tabKey: '1',
                // 地图用
                center: {lng: 104.05798, lat: 30.593601},
                polyline: {
                    editing: false,//是否修改
                    path: []
                },
                fenceShape: 'polygon',
                circularObj: {
                    center: {lat: 0, lng: 0},
                    radius: 100
                },
                polygonList: [],
                addressList:[
                    {
                        name:'茂县',
                        value:'茂县'
                    },
                    {
                        name:'汶川县',
                        value:'汶川县'
                    },
                    {
                        name:'理县',
                        value:'理县'
                    },
                    {
                        name:'壤塘县',
                        value:'壤塘县'
                    },
                    {
                        name:'阿坝县',
                        value:'阿坝县'
                    },
                    {
                        name:'马尔康',
                        value:'马尔康'
                    },
                    {
                        name:'金川',
                        value:'金川'
                    },
                    {
                        name:'小金县',
                        value:'小金县'
                    },
                    {
                        name:'红原',
                        value:'红原'
                    },
                    {
                        name:'松潘',
                        value:'松潘'
                    },
                    {
                        name:'黑水县',
                        value:'黑水县'
                    },
                    {
                        name:'若尔盖',
                        value:'若尔盖'
                    },
                ]
            }
        },
        methods: {
            // 查询
            selectOrgList() {
                this.getData({name: this.hospital});
            },
            // 新增
            addOrg() {
                this.visible = true;
            },
            // 新增人员
            addLine() {
                this.form.contacts.push({});
            },
            // 删除人员
            deleteLine(row) {
                row.isDel = '1';
                let index = this.form.contacts.findIndex(item => {
                    return item === row
                });
                this.form.contacts.splice(index, 1)
            },
            //新增-点击确定
            add() {
                this.form.positions = [];
                this.form.orderNo = this.form.orderNo + '';
                this.form.contacts.forEach(item=>{
                    item.orderNo = item.orderNo + ''
                });
                if (this.fenceShape === 'circular') {
                    this.form.positions.push(
                        {
                            lat: this.circularObj.center.lat + '',
                            lng: this.circularObj.center.lng + '',
                            radius: this.circularObj.radius + ''
                        })
                } else {
                    this.polygonList.forEach(item => {
                        this.form.positions.push({
                            lng: item.lng + '',
                            lat: item.lat + '',
                        })
                    });
                }
                orgEditDetail(this.form).then(() => {
                    this.visible = false;
                    this.getData()
                }).catch(res => {
                    this.visible = false;
                    console.log(res)
                })
            },
            // 编辑按钮
            edit(row) {
                this.tabKey = '1';
                this.form = JSON.parse(JSON.stringify(row));
                this.visible = true
            },
            //删除按钮
            del(row) {
                orgDelDetail({id: row.id}).then(() => {
                    this.getData();
                });
            },
            getData(parameter) {
                if (!parameter) {
                    parameter = {}
                }
                this.resetForm();
                this.visible = false;
                getOrgQueryList(parameter).then(res => {
                    this.data = res.data;
                })
            },
            /**
             * 重置form
             */
            resetForm() {
                this.form = {
                    orderNo: '',
                    name: '',
                    phone: '',
                    address: '',
                    descpt: '',
                    contacts: [],
                    positions: [],
                }
            },
            // 分页
            onChange(page) {
                var data = {
                    name:this.hospital,
                    baseDto:{
                        pageIndex: page,
                        pageSize: 10,
                    }
                }
                // let baseDto = {
                //     pageIndex: page,
                //     pageSize: 10,
                //     name: this.hospital
                // };
                getOrgQueryList(data).then(res => {
                    this.data = res.data;
                })
            },
            // 删除按钮
            delCar(row) {
                this.lines = row;
                this.delVisible = true;
            },
            // 删除提示
            delOk() {
                this.delVisible = false;
                this.del(this.lines);
            },
            cancel() {
                this.delVisible = false;
            },
            // 切换面板
            changeTab(key) {
                this.tabKey = key;
                if (key === '2') {
                    // this.fenceRow = this.form.positions;
                    this.polygonList = [];
                    if (this.form.positions && this.form.positions.length > 0) {
                        this.center = this.form.positions[0];
                        if (this.form.positions.length === 1) {
                            this.center = this.form.positions[0];
                            this.circularObj.center = this.form.positions[0];
                            this.circularObj.radius = this.form.positions[0].radius;
                            this.fenceShape = 'circular'
                        } else {
                            this.center = this.form.positions[0];
                            this.polygonList = this.form.positions;
                            this.fenceShape = 'polygon'
                        }
                    } else {
                        this.fenceShape = 'polygon'
                    }
                }
            },
            // 地图修改
            updateCirclePath(e) {
                this.circularObj.center = e.target.getCenter();
                this.circularObj.radius = e.target.getRadius()
            },
            syncPolyline(e) {
                if (!this.polyline.editing || this.fenceShape === 'circular') {
                    return
                }
                this.$set(this.polygonList, this.polygonList.length - 1, e.point)
            },
            paintPolyline(e) {
                if (!this.polyline.editing) {
                    return
                }
                if (this.fenceShape === 'circular') {
                    this.circularObj.center.lat = e.point.lat;
                    this.circularObj.center.lng = e.point.lng;
                    this.circularObj.radius = 100
                } else {
                    this.polygonList.push(e.point)
                }
            },
            newPolyline() {
                if (!this.polyline.editing) {
                    return
                }
                this.polyline.editing = !this.polyline.editing;
                if (this.fenceShape === 'polygon') {
                    if (!this.polyline.editing && this.polygonList.length < 3) {
                        this.polygonList = []
                    }
                }
                this.polygonList.pop();
            },
            setNull(){
                this.polyline.editing = !this.polyline.editing;
                this.form.positions= [];
            }
        },
        created() {
            this.getData();
        }
    }
</script>

<style scoped>
    .Tips {
        font-size: 20px;
        color: #1890ff;
    }

    .map {
        margin-left: 8px;
        width: 98%;
        height: 43vh;
    }
</style>
